(function () {
  'use strict';

  var store = window.WmpStore;
  var router = window.WmpRouter;

  /* Placeholder thumbnail SVG for accessories */
  var THUMB_SVG = '<svg width="60" height="60" viewBox="0 0 60 60" fill="none"><rect x="8" y="14" width="44" height="32" rx="4" stroke="currentColor" stroke-width="1.5"/><path d="M18 34l8-8 6 6 4-4 8 8" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" opacity="0.4"/></svg>';

  var actionBtn = null;
  var MAX_ACCESSORIES = 4;

  function calcAccessoriesTotal(selectedKeys) {
    var config = window.WmpProductsConfig;
    var total = 0;
    if (!config) return total;

    for (var i = 0; i < selectedKeys.length; i++) {
      var acc = config.findAccessory(selectedKeys[i]);
      if (acc) total += (acc.priceCents || 0);
    }
    return total;
  }

  function syncSelectionPricing(list) {
    var selected = list ? getSelected(list) : [];
    store.set('accessories', selected);

    var pricing = store.get('pricing');
    pricing.accessories = calcAccessoriesTotal(selected);
    store.set('pricing', pricing);

    return selected;
  }

  /* Price cell: sale price (red) + struck-through compare-at when on sale,
     otherwise the plain price. Mirrors the lens-package price markup. */
  function renderPrice(priceEl, priceCents, comparePriceCents) {
    priceEl.innerHTML = '';
    if (comparePriceCents && comparePriceCents > priceCents) {
      var sale = document.createElement('span');
      sale.className = 'wmp-card__price--sale';
      sale.textContent = store.formatPrice(priceCents);
      priceEl.appendChild(sale);
      priceEl.appendChild(document.createTextNode(' '));
      var orig = document.createElement('span');
      orig.className = 'wmp-card__price-original';
      orig.textContent = store.formatPrice(comparePriceCents);
      priceEl.appendChild(orig);
    } else {
      priceEl.textContent = store.formatPrice(priceCents);
    }
  }

  function render(container) {
    var currentAccessories = store.get('accessories') || [];

    var config = window.WmpProductsConfig;
    var accessories = config ? config.getAccessories() : [];

    // Heading
    var heading = document.createElement('h2');
    heading.className = 'wmp-flow__step-heading';
    heading.textContent = 'EYEWEAR CARE ESSENTIALS';
    container.appendChild(heading);

    if (!accessories.length) {
      // No accessories configured — skip the step entirely
      router.advance();
      return;
    }

    // Card list (single-column, horizontal cards — matches Figma)
    var list = document.createElement('div');
    list.className = 'wmp-card-list';

    for (var i = 0; i < accessories.length; i++) {
      var acc = accessories[i];
      var displayName = (acc.title || acc.key || '').toString().toUpperCase();

      var card = document.createElement('button');
      card.className = 'wmp-card';
      card.setAttribute('type', 'button');
      card.setAttribute('data-key', acc.key);
      card.setAttribute('data-price', String(acc.priceCents));

      if (currentAccessories.indexOf(acc.key) > -1) {
        card.classList.add('wmp-card--selected');
      }

      // Thumbnail — picked image or product featured image (from config), then SVG fallback
      var iconEl = document.createElement('span');
      iconEl.className = 'wmp-card__icon';
      var imgSrc = acc.image || '';
      if (imgSrc) {
        var img = document.createElement('img');
        img.src = imgSrc;
        img.alt = displayName;//width:60px;height:60px;
        img.style.cssText = 'object-fit:cover;border-radius:8px;';
        iconEl.appendChild(img);
      } else {
        iconEl.innerHTML = THUMB_SVG;
      }
      card.appendChild(iconEl);

      // Content
      var content = document.createElement('div');
      content.className = 'wmp-card__content';

      var title = document.createElement('span');
      title.className = 'wmp-card__title';
      title.textContent = displayName;
      content.appendChild(title);

      if (acc.subtitle) {
        var desc = document.createElement('span');
        desc.className = 'wmp-card__description';
        desc.textContent = acc.subtitle;
        content.appendChild(desc);
      }

      card.appendChild(content);

      // Price (right-aligned) — sale-aware
      var priceEl = document.createElement('span');
      priceEl.className = 'wmp-card__price';
      renderPrice(priceEl, acc.priceCents, acc.comparePriceCents);
      card.appendChild(priceEl);

      card.addEventListener('click', onCardClick);
      list.appendChild(card);
    }

    container.appendChild(list);

    // Keep sidebar/mobile subtotal in sync when re-entering this step.
    syncSelectionPricing(list);

    // Action button
    actionBtn = document.createElement('button');
    actionBtn.className = 'wmp-btn wmp-btn--primary wmp-btn--xl wmp-btn--full';
    actionBtn.setAttribute('type', 'button');
    actionBtn.style.marginTop = '24px';
    updateButtonText(currentAccessories.length);
    actionBtn.addEventListener('click', onContinue);
    container.appendChild(actionBtn);
  }

  function onCardClick(e) {
    var card = e.currentTarget;
    var list = card.closest('.wmp-card-list');

    // Cap selections at MAX_ACCESSORIES. Selecting beyond the cap is a no-op;
    // deselecting an already-selected card is always allowed.
    if (!card.classList.contains('wmp-card--selected') &&
        getSelected(list).length >= MAX_ACCESSORIES) {
      return;
    }

    card.classList.toggle('wmp-card--selected');
    var selected = syncSelectionPricing(list);
    updateButtonText(selected.length);
  }

  function getSelected(list) {
    var cards = list.querySelectorAll('.wmp-card--selected');
    var keys = [];
    for (var i = 0; i < cards.length; i++) {
      keys.push(cards[i].getAttribute('data-key'));
    }
    return keys;
  }

  function updateButtonText(count) {
    if (!actionBtn) return;
    actionBtn.textContent = count > 0 ? 'CONTINUE' : 'NO, THANKS';
  }

  function onContinue() {
    var list = document.querySelector('.wmp-card-list');
    syncSelectionPricing(list);

    router.advance();
  }

  function destroy() {
    actionBtn = null;
  }

  window.WmpSteps = window.WmpSteps || {};
  window.WmpSteps['accessories'] = {
    render: render,
    destroy: destroy,
    onContinue: onContinue
  };
})();
